import { ActionTypeKeys, ActionTypes } from '../actions'

export interface ExperimentsState {
  [experimentId: string]: ExperimentState
}

export interface ExperimentState {
  activated: boolean
  selectedVariantId?: string
}

export const initialExperimentsState: ExperimentsState = {}

const ExperimentReducer = (state: ExperimentsState = initialExperimentsState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.EXPERIMENT_ACTIVATED:
      return { ...state, [action.experiment.id]: { ...state[action.experiment.id], activated: true } }
    case ActionTypeKeys.EXPERIMENT_VARIANT_SELECTED:
      return {
        ...state,
        [action.experiment.id]: { ...state[action.experiment.id], selectedVariantId: action.selectedVariantId },
      }
    default:
      return state
  }
}

export default ExperimentReducer
